export default __webpack_public_path__ + "static/media/iep.0f323e82.svg";